import React from 'react';
import "./ServicesIntro.css";


function ServicesIntro() {
    return (
        <div className="servicesintro-container">
            <h1 className="servicesintro-title">What <span className = "underlined underline-overflow">We</span> Do! </h1>
            <h2 className="servicesintro-text">Experience the freedom and convenience of our car rental services by booking your vehicle today. Whether you're traveling solo, with family, or for business, we have the perfect solution to meet your transportation needs. Our easy-to-use online booking system allows you to select your desired vehicle, choose your rental period, and add any additional services you require. We look forward to serving you and making your travel experience unforgettable.</h2>
        </div>

    )
}

export default ServicesIntro;